<h5>Tarefas específicas para o FGEnergia</h5>

<div class="container">
  <div ngbAccordion>
  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">Criar questionário</button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <div class="bn-form-group">
                <label for="cnpjCliente">CNPJ beneficiário: </label>
                <input
                  type="text"
                  id="cnpjCliente"
                  [(ngModel)]="cnpjCliente"
                  class="form-control"
                  bnMask="CNPJ"
                  required
                />
              </div>
            </div>

            <div class="col-md-3">
              <label for="esco"
                >ESCO:
                <i
                  class="fa fa-question-circle help-subtitulo"
                  placement="bottom"
                  ngbTooltip="Explicação ESCO - Explicação ESCO - Explicação ESCO  "
                ></i>
              </label>
              <input
                type="checkbox"
                id="esco"
                [(ngModel)]="esco"
                class="form-check checkbox-gigante"
              />
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button
                type="submit"
                (click)="criarQuestionario()"
                class="btn btn-success no-margin"
              >
                Criar
              </button>
            </div>

            <div class="submit col-auto">
              <button
                type="button"
                (click)="onClear()"
                class="btn btn-light"
              >
                Limpar
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">
        Cancelar questionários
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="valor">CNPJ beneficiário: * </label>
              <input
                type="text"
                id="cnpjCliente"
                name="cnpjCliente"
                class="form-control"
                bnMask="CNPJ"
                ngModel
                required
                #cnpjCliente="ngModel"
              />
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button
                [disabled]="cnpjCliente.errors"
                type="submit"
                (click)="cancelarQuestionario()"
                class="btn btn-success no-margin"
              >
                Cancelar
              </button>
            </div>

            <div class="submit col-auto">
              <button
                [disabled]="!cnpjCliente.dirty"
                type="button"
                (click)="onClear()"
                class="btn btn-light"
              >
                Limpar
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">
        Buscar saldo da conta de recursos para cobertura de garantia (utilizada
        para atualização de limite do fundo)
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="col-md-3">
              <label for="anoMes"
                >Data de referência<i
                  class="fa fa-question-circle help-subtitulo"
                  placement="top-right"
                  ngbTooltip="
                 O mês de referência ao fim do qual será obtido o saldo da conta contábil no SAP para atualização do limite."
                ></i>
              </label>
              <input
                type="text"
                id="anoMes"
                class="form-control"
                bnMask="MESANO"
                [(ngModel)]="anoMesBuscaSaldoContaRecursosGarantia"
              />
            </div>
          </div>

          <div class="row">
            <div class="submit col-auto">
              <button
                type="submit"
                (click)="buscarSaldoContaRecursosCoberturaGarantia()"
                class="btn btn-success no-margin"
              >
                Buscar saldo da conta no SAP
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div ngbAccordionItem>
    <h2 ngbAccordionHeader>
      <button ngbAccordionButton class="title2">
        Atualizar limite de contratação
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div class="row">
            <div class="submit col-auto">
              <button
                type="submit"
                (click)="atualizarLimite()"
                class="btn btn-success no-margin"
              >
                Atualizar limite
              </button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  </div>
</div>